import { Button, Collapse, Divider, Modal } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	WarningMessageBox
} from "../../components/styled/common";
import { DocCategoryItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useDocumentContext } from "../../context/DocumentContext/DocumentContext";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const AddDocumentCategory = () => {
	const { addDocument, clearDocumentData, docCategoryDetail, documentForm, getDocumentCategoryDetail, setDocumentForm, operationStatus, failedUploadFiles, clearFailedUploadFiles } = useDocumentContext();
	const [isFailedFilesModalVisible, setIsFailedFilesModalVisible] = useState(false);
	const { state } = useLocation();
	const categoryId = state?.categoryId;

	useEffect(() => {
		if (failedUploadFiles.length > 0) {
			setIsFailedFilesModalVisible(true);
		}
	}, [failedUploadFiles]);

	useEffect(() => {
		clearDocumentData();

		if (categoryId) {
			getDocumentCategoryDetail(categoryId);
			if (docCategoryDetail?.categoryId) {
				setDocumentForm({
					...documentForm,
					categoryId: docCategoryDetail.categoryId
				});
			}
		}

		return () => {
			clearDocumentData();
		};
	}, [categoryId]);

	return (
		<ActionContainer>
			<ActionItemsContainer>
				<h3>Yeni Doküman Ekleme</h3>
				<Divider />
				<Collapse
					items={DocCategoryItems}
					expandIconPosition="end"
					bordered={false}
					ghost
					expandIcon={CollapseExpandIcon}
					defaultActiveKey={["1", "2"]}
				/>
				<SubmitButtonOverlay>
					<MainButtonComponent onClick={addDocument} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Dokümanı Ekle
					</MainButtonComponent>
				</SubmitButtonOverlay>
				<Modal
					title="Yüklenemeyen Dokümanlar"
					open={isFailedFilesModalVisible}
					onCancel={() => {
						clearFailedUploadFiles();
						setIsFailedFilesModalVisible(false);
					}}
					centered
					footer={[
						<Button key="confirm" type="primary" danger onClick={() => {
							clearFailedUploadFiles();
							setIsFailedFilesModalVisible(false);
						}}>
							Tamam
						</Button>,
					]}
				>
					<p>Aşağıdaki dosyalar kategoride bulunmaktadır. Lütfen belirtilen dosyaları çıkartıp tekrar deneyiniz.</p>
					<WarningMessageBox>
						<ul>
							{failedUploadFiles.map((fileName) => (
								<li style={{ listStyleType: "none" }} key={fileName}>{fileName}</li>
							))}
						</ul>
					</WarningMessageBox>
				</Modal>
			</ActionItemsContainer>
		</ActionContainer>
	);
};

export default AddDocumentCategory;
